import {
  NOT_COIN_CLAIM_DONE_LS_KEY,
  RECHARGE_DROP_DONE_LS_KEY,
} from '../constants'
import { ClaimRewardDoneLsKey } from '../type'

const setLsClaimDone = (lsKey: ClaimRewardDoneLsKey) => {
  localStorage.setItem(lsKey, 'true')
}

export const setNotCoinClaimDone = () => {
  setLsClaimDone(NOT_COIN_CLAIM_DONE_LS_KEY)
}

export const setRechargeDropDone = () => {
  setLsClaimDone(RECHARGE_DROP_DONE_LS_KEY)
}
